import { notifySnackbarByName, openModalByName, ResourceAction } from 'ia-react-core';
import React, { FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Constants from '../../utils/Constants';
import getApiRoot from '../../utils/getApiRoot';
import ConfirmDeleteMessage from './ConfirmDeleteMessage';
import { StyledButton } from './DeleteMessagesButton.styles';

export interface DeleteMessagesButtonProps {
  messageSource: string;
  messageIds: number[];
  buttonText?: string;
  showCount?: boolean;
  successMessage: string;
  handleSuccess: () => void;

}

const DeleteMessagesButton: FC<DeleteMessagesButtonProps> = ({ messageSource, messageIds, buttonText, showCount = true, successMessage, handleSuccess }) => {
  const { t } = useTranslation('DeleteMessagesButton');
  const countMessagesDisplay = useMemo(() => showCount && messageIds.length > 0 ? (`(${messageIds.length})`) : '', [showCount, messageIds]);
  const isButtonDisabled = useMemo(() => messageIds.length === 0, [messageIds]);

  const dispatch = useDispatch();

  const onSuccess = () => {
    handleSuccess();
    dispatch(notifySnackbarByName(Constants.ComposantsName.ClientSpaceSnackBar, successMessage));
  };

  const handleDeleteMessage = useCallback(() => {
    dispatch(openModalByName('confirmDeleteMessage'));
  }, [dispatch]);

  return (
    <>
      <ResourceAction
        name="deleteMessagesResource"
        url={`${getApiRoot()}/messages/markasdeleted`}
        method="POST"
        data={{
          messageIds,
          messageSource,
        }}
        onSuccess={onSuccess}
      >
        {({ pending }) => (
          <StyledButton
            busy={pending}
            disabled={isButtonDisabled}
            outline
            onClick={handleDeleteMessage}
          >
            {buttonText || t('deleteButtonText')} {countMessagesDisplay}
          </StyledButton>
        )}
      </ResourceAction>
      <ConfirmDeleteMessage isMultiple={messageIds.length > 1} />
    </>
  );
};
export default DeleteMessagesButton;
